import Spacer from '@berlitz/spacer'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { EmptyResultWrapper } from './style'

const EmptyResults: React.FC = () => {
  const intl = useIntl()
  return (
    <EmptyResultWrapper>
      <div>
        <FormattedMessage id="Sorry, no instructors were found." defaultMessage="Sorry, no instructors were found." />
      </div>
      <div>
        <FormattedMessage
          id="Please adjust your search criteria and try again."
          defaultMessage="Please adjust your search criteria and try again."
        />
      </div>
      <Spacer size="lg" />
      <Spacer size="xxxs" />
      <div>
        <img
          src={'/images/no-results.svg'}
          alt={intl.formatMessage({ id: 'Sorry, no instructors were found.' })}
          width={'100%'}
        />
      </div>
      <Spacer size="lg" />
    </EmptyResultWrapper>
  )
}

export default EmptyResults
